import type { InputType } from 'config'

export const aiPromptTemplateInputs = (): Record<string, InputType> => ({
  title: {
    inputType: 'Text',
    title: 'Title',
    required: true,
    span: 2,
  },
  projectId: {
    inputType: 'select',
    title: 'AI Project',
    hasDefaultOption: true,
    defaultOptionText: '- None -',
    options: {},
    span: 2,
  },
  prompt: {
    inputType: 'textarea',
    title: 'Prompt',
    rows: 8,
    required: true,
    span: 'full',
  },
})
